import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems,  } from 'resolvers/getVisibleEntities';
import { resolveEntityCellData } from  'resolvers/resolveEntityCellData';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberClaimDetailSummary defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberClaimDetailSummaryService } from 'services/memberClaimDetailSummary';
 *
 * // create service instance and send/cancel request
 * const memberClaimDetailSummaryService = new MemberClaimDetailSummaryService();
 * const result = await memberClaimDetailSummaryService.fetchData( '<user-id>' ); // fetch data
 * memberClaimDetailSummaryService.cancel(); // cancel an active request
 */
export class MemberClaimDetailSummaryService extends HttpService {

     // make request and fetch data
     async fetchComponentData( { url, data } ) {
        try {

            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            const component = get( response, 'body.component', {} );
            const visibility = get( component, 'visibility', {} );
            const fields = get( component, 'structure.fields', {} );
            const widgetConfig =  get( component, 'structure.widgetConfig', {} );
            const sections = get( component, 'structure.sections', {} );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: {
                    claimData: get( response, 'body.component.data.state', {} ),
                    fields: resolveEntityCellData( { items: getVisibleItems( fields, visibility ), component } ),
                    sections: ( getVisibleItems( sections, visibility ) ),
                    visibility,
                    widgetConfig,
                    summaryActions: getVisibleItems( get( component, 'structure.summaryActions', [] ), visibility )
                }
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    async fetchClaimToDoForm( { url, data } ) {

        const response = await this.post( {
            host: CONFIG.host,
            path: url,
            data,
        } );

        return {
            status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
            data: {
                options: get( response, 'body.component.data.options', {} ),
                state: get( response, 'body.component.data.state', {} ),
                ...get( response, 'body.component.structure', {} ),

                // actions: get( response, 'body.component.structure.actions', {} ),
                // fields: get( response, 'body.component.structure.fields', {} ),
                // primaryColumns: get( response, 'body.component.structure.primaryColumns', {} )
            }
        };
        
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
